import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ROUTES as API_ROUTES } from "../../constants/api";
import { GetApiData } from "../../api/general";
import useErrorModal from "../useErrorModal";

// types 
import type {
  SendMoneyCountriesResponse
} from "../../types/api/sendMoney";
import type { Country } from "../../types/moneyTransfer";
import { RootState } from "../../types/redux";
import { FieldOption } from "../../types/components/dynamicForms";

const useGetSendMoneyCountries = () => {
  const openErrorModal = useErrorModal();
  const transferMethod = useSelector(
    (state: RootState) => state.sendMoney.transferMethod
  );
  const [loading, setLoading] = useState(true);
  const [countries, setCountries] = useState<Country[]>([]);
  const [countryOptions, setCountryOptions] = useState<FieldOption[]>([]);
  const [banners, setBanners] = useState<SendMoneyCountriesResponse["result"]["banners"]>([]);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const getCountries = async () => {
      try {
        setLoading(true);

        const url =
          API_ROUTES.SEND_MONEY.GET_SEND_MONEY_COUNTRIES(transferMethod);

        const response = await GetApiData<SendMoneyCountriesResponse>(url);

        const resultCountries = response.result.countries ?? [];
        setCountries(resultCountries);
        setCountryOptions(
          resultCountries.map((country) => ({
            label: country.name,
            value: country.iso,
          }))
        );
        setBanners(response.result.banners ?? []);
      } catch (err) {
        setHasError(true);
        openErrorModal(err);
      } finally {
        setLoading(false);
      }
    };

    getCountries();
  }, [transferMethod]);

  return {
    loading,
    countries,
    countryOptions,
    banners,
    hasError,
  };
};

export default useGetSendMoneyCountries;